import request from '@/utils/request'
import {
  JSON_CONFIG,
} from '@/utils/helper.js'

export function getPatientProfile (pid) {
  return request({
    url: `/front/medical/patient/${pid}`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getPatientContestRecord (pid) {
  return request({
    url: `/front/medical/patient/${pid}/record`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getPatientContestReport (pid, date, temId) {
  return request({
    url: `/front/patient/${pid}/report`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      date: date,
      temId: temId
    }
  })
}

export function getPatientSummary (pid) {
  return request({
    url: `/front/medical/patient/${pid}/summary`,
    method: 'get',
    header: JSON_CONFIG
  })
}

// 動作歷史（登入版；後端工單 31，報告改版工單 32 的病患總覽趨勢）：query 由呼叫端組好（重複的 analysisKey=、lang；
// src/report/overview/overview-history.js 的 historyQuery——axios 預設把陣列序列化成 analysisKey[]=，後端讀不到）。
// validateStatus 全收：非 200 時 utils/request.js 回原始 response（帶 status），呼叫端依狀態分類（403／208＝無授權、其餘＝失敗）；
// 網路錯照舊 reject。
export function getPatientActionHistory (pid, query) {
  return request({
    url: `/front/medical/patient/${encodeURIComponent(pid)}/history?${query}`,
    method: 'get',
    validateStatus: () => true
  })
}
